<script setup>
// Addendum §7 Breadcrumbs — ONLY at ≥3 levels of drill-down; shallower is
// noise. This component renders nothing below the threshold so callers can pass
// the trail unconditionally and trust the rule. The last crumb is the current
// page (aria-current="page"), not a link.
import { computed } from 'vue'
import LIcon from '../base/Icon.vue'

const props = defineProps({
	items: { type: Array, required: true }, // [{ label, href?, to? }] — `to` renders a router-link (SPA nav), `href` a plain anchor
	minLevels: { type: Number, default: 2 },
})
const show = computed(() => props.items.length >= props.minLevels)
</script>

<template>
	<nav v-if="show" class="l-crumbs" aria-label="Breadcrumb">
		<ol>
			<li v-for="(c, i) in items" :key="i">
				<router-link v-if="i < items.length - 1 && c.to" :to="c.to" class="crumb">{{ c.label }}</router-link>
				<a v-else-if="i < items.length - 1 && c.href" :href="c.href" class="crumb">{{ c.label }}</a>
				<span v-else-if="i < items.length - 1" class="crumb">{{ c.label }}</span>
				<span v-else class="crumb current" aria-current="page">{{ c.label }}</span>
				<LIcon v-if="i < items.length - 1" name="chevron-right" :size="11" class="sep" aria-hidden="true" />
			</li>
		</ol>
	</nav>
</template>

<style scoped>
.l-crumbs ol
{
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 4px;
	list-style: none;

	padding-left: 0;
}

.l-crumbs li
{
	display: inline-flex;
	align-items: center;
	gap: 4px;
}

.crumb
{
	font-size: var(--text-sm);
	color: var(--text-3);
	text-decoration: none;
}

a.crumb:hover
{
	color: var(--interactive-text);
	text-decoration: underline;
	text-underline-offset: 2px;
}

.crumb.current
{
	color: var(--text);
	font-weight: 600;
}

.sep
{
	color: var(--decorative);
}
</style>
